import { Component, OnDestroy, OnInit, Output, EventEmitter, Input } from "@angular/core";
import { SelectOverlayAction } from "@edp-store/actions/layout.actions";
import { IAppState } from "@edp-store/state/app.state";
import { select, Store } from "@ngrx/store";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { environment } from "@edp-environments/environment";
import { GetMgmCode, SendShareSocial } from "@edp-store/actions/edpe.actions";
import { getMgmCode } from "@edp-store/selectors/edpe.selector";
import { MgmCode } from "@edp-models/edpe-mgm";
import { CopyClipboardService } from "@edp-services/copy-clipboard.service";

@Component({
    selector: "edp-overlay-mgm",
    templateUrl: "./edp-overlay-mgm.component.html",
    styleUrls: ["./edp-overlay-mgm.component.scss"],
})
export class EdpOverlayMgmComponent implements OnInit, OnDestroy {
    @Input() public origin: string;
    @Output() public closeSideBar = new EventEmitter<boolean>();
    private unsubscribe = new Subject();
    public mgm: MgmCode;

    public constructor(private store: Store<IAppState>, private readonly copyClipboard: CopyClipboardService) {}

    public ngOnInit(): void {
        this.store.dispatch(new GetMgmCode());
        this.store.pipe(takeUntil(this.unsubscribe), select(getMgmCode)).subscribe((mgm: MgmCode) => {
            if (mgm) {
                this.mgm = mgm;
            }
        });
    }

    public selectOverlay(type: string): void {
        if (environment.isApp || (sessionStorage.getItem("mgm") && sessionStorage.getItem("mgm") === "planeta")) {
            sessionStorage.removeItem("mgm");
            this.closeSideBar.emit(true);
            this.store.dispatch(new SelectOverlayAction(null));
        } else {
            this.store.dispatch(new SelectOverlayAction(type));
        }
    }

    public copyCode(copy: string) {
        this.copyClipboard.copyToClipboard(copy);
        this.store.dispatch(new SendShareSocial({ type: "copy_code" }));
    }

    public ngOnDestroy() {
        this.unsubscribe.next();
        this.unsubscribe.complete();
    }
}
